import apis from "../../core/apis.js";

class RedirectorResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.redirector).get(options);
  }

  get(id) {
    return this.$resource(apis.redirector + id).get();
  }

  search(search = "") {
    return this.$resource(apis.redirector).get({ search });
  }

  post(item) {
    return this.$resource(apis.redirector).save(item);
  }

  update(id, item) {
    return this.$resource(apis.redirector + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
}

export default RedirectorResource;



// WEBPACK FOOTER //
// ./src/resources/redirector/redirector.resource.js